export const IQ_DOM = {
  root: 'iq-ui',
  pauseRoot: 'iq-pause',
  gameOverRoot: 'iq-gameover',
} as const;
